import axios from './axios'
// import qs from "qs";

function service(endpoint) {
    function saveMany(data) {
        return axios.post(`${endpoint}/many`, data).then(response => {
            return response;
        }).catch(e => {
            throw e;
        });
    }

    return {
        saveMany
    }
}

export default service
